module.exports = __webpack_public_path__ + "static/media/IMG_3561.4b9d7ed8.jpg";